import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

console.log("BRIDGE CHECK:", {
  rnBridge: !!window.ReactNativeWebView,
  customBridge: window.__CENTE_BRIDGE__,
  platform: window.__CENTE_PLATFORM__,
  userAgent: navigator.userAgent
});

bootstrapApplication(AppComponent, appConfig).catch(console.error);
